__turbopack_context__.v({
  "descriptionText": "PlasmicSectionHeader-module__7hiw4q__descriptionText",
  "sectionHeader": "PlasmicSectionHeader-module__7hiw4q__sectionHeader",
  "subtitleText": "PlasmicSectionHeader-module__7hiw4q__subtitleText",
  "titleText": "PlasmicSectionHeader-module__7hiw4q__titleText",
  "top": "PlasmicSectionHeader-module__7hiw4q__top",
});
